module.exports = __webpack_public_path__ + "img/avatar9.910abdc6.png";